import { render, staticRenderFns } from "./CustomerInfoPanel.vue?vue&type=template&id=3846978c&scoped=true&"
import script from "./CustomerInfoPanel.vue?vue&type=script&lang=js&"
export * from "./CustomerInfoPanel.vue?vue&type=script&lang=js&"
import style0 from "./CustomerInfoPanel.vue?vue&type=style&index=0&id=3846978c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3846978c",
  null
  
)

export default component.exports